import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiOutlineMap({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.06708 2.70436C6.02485 2.68325 5.97515 2.68325 5.93292 2.70436L2.68292 4.32936C2.6321 4.35477 2.6 4.40671 2.6 4.46353V12.7865C2.6 12.898 2.71735 12.9705 2.81708 12.9206L5.39626 11.6311C5.77632 11.441 6.22368 11.441 6.60374 11.6311L9.93292 13.2956C9.97515 13.3168 10.0249 13.3168 10.0671 13.2956L13.3171 11.6706C13.3679 11.6452 13.4 11.5933 13.4 11.5365V3.21353C13.4 3.10202 13.2827 3.02949 13.1829 3.07936L10.6037 4.36895C10.2237 4.55898 9.77632 4.55898 9.39626 4.36895L6.06708 2.70436ZM5.39626 1.63105C5.77632 1.44102 6.22368 1.44102 6.60374 1.63105L9.93292 3.29564C9.97515 3.31675 10.0249 3.31675 10.0671 3.29564L12.6463 2.00605C13.5439 1.55724 14.6 2.20996 14.6 3.21353V11.5365C14.6 12.0478 14.3111 12.5153 13.8537 12.744L10.6037 14.369C10.2237 14.559 9.77632 14.559 9.39626 14.369L6.06708 12.7044C6.02485 12.6832 5.97515 12.6832 5.93292 12.7044L3.35374 13.994C2.45612 14.4428 1.4 13.79 1.4 12.7865V4.46353C1.4 3.95218 1.6889 3.48473 2.14626 3.25605L5.39626 1.63105ZM6 3.9C6.33137 3.9 6.6 4.16863 6.6 4.5V10C6.6 10.3314 6.33137 10.6 6 10.6C5.66863 10.6 5.4 10.3314 5.4 10V4.5C5.4 4.16863 5.66863 3.9 6 3.9ZM10 5.4C10.3314 5.4 10.6 5.66863 10.6 6V11.5C10.6 11.8314 10.3314 12.1 10 12.1C9.66863 12.1 9.4 11.8314 9.4 11.5V6C9.4 5.66863 9.66863 5.4 10 5.4Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgHiOutlineMap;
